import React, { memo } from 'react';
import {
    Wrapper,
    IconWrapper,
    MessageWrapper,
    SmallPrintWrapper,
} from './MessageTile.styles';
import {
    Text,
    TextPreset,
    ShadeColor,
    Tag,
} from '@pegasus/ui-components/components/text';
import { Title, TitlePreset } from '@pegasus/ui-components/components/title';

interface MessageTileProps {
    icon: React.FunctionComponent;
    title: string | JSX.Element;
    message?: string | JSX.Element;
    smallPrints?: (JSX.Element | string)[];
}

const MessageTile = memo(
    ({ icon: Icon, title, message, smallPrints = [] }: MessageTileProps) => {
        return (
            <Wrapper>
                <IconWrapper>
                    <Icon />
                </IconWrapper>
                <MessageWrapper>
                    <Title preset={TitlePreset.S} className="header">
                        {title}
                    </Title>
                    {message && <Text preset={TextPreset.XXS}>{message}</Text>}
                    {smallPrints.length > 0 && (
                        <SmallPrintWrapper>
                            {smallPrints.map((print, i) => (
                                <Text
                                    preset={TextPreset.XXS}
                                    color={ShadeColor.dark60}
                                    tag={Tag.P}
                                    className="small-print"
                                    key={i}
                                >
                                    {print}
                                </Text>
                            ))}
                        </SmallPrintWrapper>
                    )}
                </MessageWrapper>
            </Wrapper>
        );
    },
);

export default MessageTile;
